import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const SocialFacebook = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M14.002 30C12.967 30 11.985 29.595 11.231 28.855C10.449 28.087 10 27.022 10 25.932V22C7.794 22 6 20.206 6 18C6 15.794 7.794 14 10 14V11C10 6.037 14.037 2 19 2H22C24.206 2 26 3.794 26 6C26 8.206 24.206 10 22 10H20C18.897 10 18 10.897 18 12V14H20C22.206 14 24 15.794 24 18C24 20.206 22.206 22 20 22H18V26C18 28.164 16.24 29.958 14.077 29.999C14.052 29.999 14.027 30 14.002 30V30ZM10 16C8.897 16 8 16.897 8 18C8 19.103 8.897 20 10 20H11C11.552 20 12 20.448 12 21V25.932C12 26.488 12.23 27.034 12.632 27.427C13.018 27.806 13.521 28.011 14.039 27.999C15.12 27.979 16 27.081 16 25.999V20.999C16 20.447 16.448 19.999 17 19.999H20C21.103 19.999 22 19.102 22 17.999C22 16.896 21.103 15.999 20 15.999H17C16.448 15.999 16 15.551 16 14.999V11.999C16 9.793 17.794 7.999 20 7.999H22C23.103 7.999 24 7.102 24 5.999C24 4.896 23.103 3.999 22 3.999H19C15.14 3.999 12 7.139 12 10.999V14.999C12 15.551 11.552 15.999 11 15.999H10V16Z" />
	</svg>
);

export default SocialFacebook;
